import { useState } from "react";
import { Trash2 } from "lucide-react";

const input = "mt-1 w-full rounded-md border border-linen bg-ivory px-3 py-2 text-sm outline-none focus:border-forest";
const label = "text-xs font-semibold uppercase tracking-[0.15em] text-moss";
const btn = "rounded-md bg-forest px-4 py-2 text-sm font-semibold text-ivory transition-colors hover:bg-forest-dark disabled:opacity-50";

export function PatientCreditCard({ data, email, api, run }) {
  const [entry, setEntry] = useState({ amount: "", kind: "redeem", note: "" });

  const submit = (e) => {
    e.preventDefault();
    run(() => api.post(`/admin/patients/${encodeURIComponent(email)}/credits`, { ...entry, amount: Number(entry.amount) }).then(() => setEntry({ amount: "", kind: "redeem", note: "" })), entry.kind === "redeem" ? "Redemption recorded" : "Credit added");
  };

  return (
    <section data-testid="patient-credit" className="rounded-lg border border-linen bg-ivory p-5">
      <div className="flex items-start justify-between gap-4">
        <h3 className="font-serif text-xl font-medium text-forest">Banked credit</h3>
        <p data-testid="patient-credit-balance" className="font-serif text-2xl text-forest">${data.credit_balance.toFixed(2)}</p>
      </div>
      <p className="mt-1 text-xs text-moss">Membership fees bank automatically each cycle. Record a redemption when the patient uses their credit at a visit.</p>
      <form onSubmit={submit} className="mt-4 space-y-3">
        <div className="grid gap-3 sm:grid-cols-2">
          <div><label className={label}>Type</label>
            <select data-testid="credit-kind-select" value={entry.kind} onChange={(e) => setEntry({ ...entry, kind: e.target.value })} className={input}>
              <option value="redeem">Redeem (used at visit)</option>
              <option value="credit">Add credit</option>
            </select>
          </div>
          <div><label className={label}>Amount ($)</label><input data-testid="credit-amount-input" type="number" min="0.01" step="0.01" required value={entry.amount} onChange={(e) => setEntry({ ...entry, amount: e.target.value })} className={input} /></div>
        </div>
        <div><label className={label}>Note (optional)</label><input data-testid="credit-note-input" value={entry.note} onChange={(e) => setEntry({ ...entry, note: e.target.value })} placeholder="Applied to 20 units Botox" className={input} /></div>
        <button type="submit" data-testid="credit-save-button" className={btn}>{entry.kind === "redeem" ? "Record Redemption" : "Add Credit"}</button>
      </form>
      <ul className="mt-5 divide-y divide-linen text-sm">
        {data.credits.map((c) => (
          <li key={c.id} data-testid={`credit-row-${c.id}`} className="flex items-center justify-between gap-3 py-2">
            <span className="text-forest">{c.note} <span className="text-xs text-moss">· {c.date}</span></span>
            <span className="flex items-center gap-3">
              <span className={`font-semibold ${c.kind === "credit" ? "text-forest" : "text-destructive"}`}>{c.kind === "credit" ? "+" : "−"}${c.amount.toFixed(2)}</span>
              <button onClick={() => run(() => api.delete(`/admin/credits/${c.id}`), "Removed")} className="text-moss hover:text-destructive" aria-label="Delete"><Trash2 size={14} /></button>
            </span>
          </li>
        ))}
        {data.credits.length === 0 && <li className="py-2 text-xs text-moss">No credit activity yet. Activate a membership to start banking.</li>}
      </ul>
    </section>
  );
}
